import { defineStore } from 'pinia'
import { useRequest } from 'composables/useRequest.js'

// Reference catalog (name + type + vendor) used to power autocomplete
// suggestions when creating an org IT component. Scoped per organization —
// unlike globalApplications.js, this isn't the same list for everyone: it
// includes approved catalog entries (visible org-wide) plus this org's own
// pending (unapproved) submissions. See
// Api::V1::Organizations::GlobalComponentsController. Fetched once per
// organization per session and reused from then on.
export const useGlobalComponentsStore = defineStore('globalComponents', {
  state: () => ({
    organizationId: null,
    components: [],
    loading: false,
    fetchedAt: null,
  }),

  actions: {
    async fetchIfNeeded(organizationId) {
      if (this.loading) return
      if (this.organizationId === organizationId && this.fetchedAt) return

      this.organizationId = organizationId
      this.loading = true
      try {
        const { axiosRequest } = useRequest()
        const res = await axiosRequest('GET', `/api/v1/organizations/${organizationId}/global_components`, {}, false)
        if (!res.js_error && res.response.success) {
          this.components = res.response.data
          this.fetchedAt = Date.now()
        }
      } finally {
        this.loading = false
      }
    },
  },
})
